var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.272 7.273H9.454a.727.727 0 0 1-.727-.728V.727A.727.727 0 0 1 9.454 0h5.818a.727.727 0 0 1 .727.727v5.818a.727.727 0 0 1-.727.728m-5.09-1.455h4.364V1.455h-4.364Z",
    "data-name": "Path 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.363 16a3.636 3.636 0 1 1 3.636-3.636A3.636 3.636 0 0 1 12.363 16m0-5.818a2.182 2.182 0 1 0 2.182 2.182 2.18 2.18 0 0 0-2.182-2.182",
    "data-name": "Path 5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.545 8.727H.727A.727.727 0 0 0 0 9.454v5.818a.727.727 0 0 0 .727.727h5.818a.727.727 0 0 0 .727-.727V9.454a.727.727 0 0 0-.727-.727m-.727 5.818H1.455v-4.363h4.363Z",
    "data-name": "Path 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.545 7.273H.727A.727.727 0 0 1 0 6.545V.727A.727.727 0 0 1 .727 0h5.818a.727.727 0 0 1 .727.727v5.818a.727.727 0 0 1-.727.728m-5.09-1.455h4.363V1.455H1.455Z",
    "data-name": "Path 7"
  })));
};
export default SvgDashboard;